(function () {
    'use strict';
    angular
        .module('jotApp')
        .factory('TabObjectsDashboard', TabObjectsDashboard)
        .factory('TabObjectsMap', TabObjectsMap);

    TabObjectsDashboard.$inject = ['$resource'];

    function TabObjectsDashboard($resource) {
        var resourceUrl = 'api/tab-objects-dashboard';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'stat': {method: 'GET', isArray: true,url:'api/tab-objects-dashboard-stat'},
            'trend' : {method: 'GET', isArray: true, url: 'api/tab-objects-dashboard-trend'},
            'graph' : {method: 'GET', isArray: true, url: 'api/tab-objects-dashboard-graph'}
        });
    }

    TabObjectsMap.$inject = ['$resource'];

    function TabObjectsMap($resource) {
        var resourceUrl = 'api/tab-objects-dashboard-map';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'home': {method: 'GET', isArray: true, url: 'api/home-map'},
            'homeOnline': {method: 'GET', isArray: true, url: 'api/home-map-on'}
        });
    }


})();
